import axios from "../utils/axios";

export function GetUsersTickets() {
  return axios.get(`/TasksBoard/GetUsersTickets`);
}